<script setup lang="ts">
import { computed } from 'vue'

import type { MultiSelectObjectOption } from '@collector/shared-ui'
import type { BaseParticipant } from '@collector/sportsapi-client-legacy'

type Props = {
  option: MultiSelectObjectOption
}
const props = defineProps<Props>()

// computed
const baseText = computed(() => {
  const participant = props.option.metadata as BaseParticipant
  return participant.short_name
})
const extendedText = computed(() => {
  const participant = props.option.metadata as BaseParticipant
  return `(${participant.area_name}) ${participant.details.birthdate}`
})
</script>

<template>
  <div>
    <span>{{ baseText }}</span>
    <span class="text-neutral-dark-3/60">{{ ' ' }}{{ extendedText }}</span>
  </div>
</template>
